export default {
  default: () => import("/home/runner/work/rediredi-storefront/rediredi-storefront/layouts/default.vue").then(m => m.default || m)
}